// extracted by mini-css-extract-plugin
export default {"container":"styles_container__hvXii","trustedCard":"styles_trustedCard__3TSy7","trustedImage":"styles_trustedImage__f+AaH","trustedTitle":"styles_trustedTitle__O5IPj"};